module.exports = __webpack_public_path__ + "static/media/splashLogin.ed6c851c.jpg";